import styled from '@emotion/styled';
import { rem } from '@utils';

const MAX_LABEL_COLUMN_WIDTH = rem(232);

const BarChartSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
  width: 100%;
`;

const BarChartLayout = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const LabelColumn = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  min-width: 0;
  width: min(40%, ${MAX_LABEL_COLUMN_WIDTH});
`;

const LabelHeader = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey['200']};
  flex-shrink: 0;
  min-height: ${rem(32)};
  width: 100%;
`;

const ChartColumn = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  min-width: 0;
`;

const ChartHeader = styled.div`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey['200']};
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  min-height: ${rem(32)};
  width: 100%;
`;

const ChartArea = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: ${rem(32)};
  position: relative;
  width: 100%;
`;

const MetricLabel = styled.span`
  color: ${({ theme }) => theme.palette.common.black};
  font-size: ${rem(12)};
  font-weight: ${({ theme }) => theme.typography.fontWeightSemiBold};
  line-height: ${rem(16)};
`;

const DataList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const DataListItem = styled.div`
  color: ${({ theme }) => theme.palette.common.black};
  font-size: ${rem(12)};
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  line-height: ${rem(16)};
  min-height: ${rem(12)};
  overflow: hidden;
  padding: ${rem(8)} 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey['200']};
`;

const Separator = styled.div<{
  x: number;
  y: number;
}>`
  background: var(--chart-grid-color);
  height: 1px;
  left: ${({ x }) => rem(x)};
  position: absolute;
  right: 0;
  top: ${({ y }) => rem(y)};
  z-index: 1;
`;

export default {
  BarChartSection,
  BarChartLayout,
  LabelColumn,
  LabelHeader,
  ChartColumn,
  ChartHeader,
  ChartArea,
  MetricLabel,
  DataList,
  DataListItem,
  Separator
};
